module.exports = __webpack_public_path__ + "static/topography-e2d78e2db94f3311219fda0e836511cf.svg";